export default __webpack_public_path__ + "static/v2_amalia_bw-6684185017f862cc7da75bfb91d65fc1.jpg";